import React, { FC, useCallback, useMemo } from 'react';
import {
  Checkbox,
  FormControl,
  FormControlProps,
  FormHelperText,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Theme,
  styled,
} from '@material-ui/core';
import { CustomInput, CustomInputLabel } from './CustomForm';

export type FilterOption = {
  id: string;
  name?: string;
  selected: boolean;
  title?: string;
};

const NewCustomFormControl = styled(FormControl)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: theme.config.defaultBorder(),
  borderRadius: theme.config.defaultBorderRadius,
  boxShadow: theme.config.defaultBoxShadow,
  maxWidth: '50%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: theme.palette.grey['900'],
  fontSize: theme.typography.h3.fontSize,
  padding: theme.spacing(1, 2),
  '&.disabled': {
    opacity: 0.5,
  },
}));

type FilterProps = Omit<
  FormControlProps,
  'id' | 'label' | 'value' | 'onChange' | 'options' | 'emptyOption' | 'disabled' | 'placeholder'
> & {
  id: string;
  label: string;
  value?: string[];
  onSelectItem: (id: string) => void;
  options: FilterOption[];
  emptyOption?: boolean;
  disabled?: boolean;
  placeholder?: string;
  helperText?: string;
};

/* TODO - REMOVE REFERENCES TO GRADES OR METHODES - LEVEL UP IN ABSTRACTION*/
const MultipleFilter: FC<FilterProps> = ({
  id,
  label,
  value = [],
  onSelectItem,
  options,
  emptyOption,
  placeholder,
  helperText,
  ...props
}) => {
  const labelId = useMemo(() => `${id}-label`, [id]);

  const handleChange = useCallback((event: any) => {
    const selectedId = event.target.value.pop();
    onSelectItem(selectedId);
  }, [onSelectItem])

  return (
    <NewCustomFormControl className={`filter ${props.disabled ? 'disabled' : ''}`} {...props}>
      <CustomInputLabel id={labelId}>{label}</CustomInputLabel>
      <Select
        style={{ overflow: 'hidden', maxWidth: '800px' }}
        id={id}
        labelId={labelId}
        input={<CustomInput />}
        multiple
        value={options}
        onChange={handleChange}
        displayEmpty={emptyOption}
        renderValue={() =>
          options
            .filter((m) => m.selected)
            .map((m) => (m.name ? m.name : m.title))
            .join(', ')
        }
      >
        {emptyOption && <MenuItem value="">{placeholder}</MenuItem>}
        {options.map((methode) => {
          return (
            <MenuItem key={methode.id} value={methode.id}>
              <ListItemIcon>
                <Checkbox 
                  checked={methode.selected} 
                  color='primary' />
              </ListItemIcon>
              <ListItemText primary={methode.name || methode.title} />
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </NewCustomFormControl>
  );
};

export default MultipleFilter;
